export const environment = {
  local: false,
  dev: false,
  staging: true,
  production: false,
  apiURL: "https://oma-lh-staging-api.herokuapp.com",
  serviceURL: "https://oma-lh-staging-services.herokuapp.com",
  openWeatherMapAPIKey: "9818527be376d5bedb7471f345826644",
  tripistScriptUrl: "https://tripist-staging.lighthousepe.ai/tripist.min.js",
  tripistEnvironment: "staging"
};
